import Logo from "@/components/landing/Logo";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0D10] px-5" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-xl border border-white/[0.1] bg-[#12161F] p-10 text-center">
        <div className="flex justify-center"><Logo size={40} /></div>
        <XCircle className="mx-auto mt-6 h-10 w-10 text-slate-500" />
        <h1 className="mt-5 font-display text-xl font-bold text-slate-50">Checkout canceled</h1>
        <p className="mt-2 text-sm leading-relaxed text-slate-400">
          No charge was made. Your account was created — you can pick up payment
          anytime to activate it.
        </p>
        <div className="mt-6 space-y-3">
          <a href="/signup" data-testid="cancel-retry-button" className="block rounded-md bg-[#F25F22] py-3 text-sm font-semibold text-white transition-colors hover:bg-[#FF7539]">
            Try Again
          </a>
          <a href="/" className="block text-xs text-slate-500 hover:text-slate-300">Back to site</a>
        </div>
      </div>
    </div>
  );
}
